"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
function SvgMovies(props) {
    return ((0, jsx_runtime_1.jsxs)("svg", __assign({ viewBox: "0 0 40 40", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props, { children: [(0, jsx_runtime_1.jsx)("path", { d: "M5.545 16.02h28.432c.988 0 1.79.802 1.79 1.79v14.788a1.79 1.79 0 01-1.79 1.79H7.335a1.79 1.79 0 01-1.79-1.79V16.02z", stroke: "currentColor", strokeWidth: 2, strokeLinecap: "square" }, void 0), (0, jsx_runtime_1.jsx)("path", { clipRule: "evenodd", d: "M4.895 11.104A1.79 1.79 0 016.412 9.09L32.796 5.26a1.79 1.79 0 012.031 1.53l.384 2.818a1.79 1.79 0 01-1.517 2.013l-28.172 4.09-.627-4.607z", stroke: "currentColor", strokeWidth: 2, strokeLinecap: "square" }, void 0), (0, jsx_runtime_1.jsx)("path", { d: "M10.878 8.674L8.211 15.56M17.99 7.755l-2.668 6.429M24.656 6.837l-2.223 5.97M31.322 5.918l-2.222 5.97", stroke: "currentColor", strokeWidth: 2, strokeLinecap: "round", strokeLinejoin: "round" }, void 0)] }), void 0));
}
exports.default = SvgMovies;
//# sourceMappingURL=Movies.js.map